export {
    initAxiosInterceptors,
    FindLoad,
    FindSuccess,
    FindSuccessItem,
    FindError,
    FindErrorItem,
    useWindowSize,
    useWindowDimensions,
    SaveParams,
    SavePage,
    getSkipCount,
    SendPageSave,
    Notify,
    RenderScroll,
    ProfileInfo,
    formatPhoneNumber,
    DownloadFile,
    IsImageLoaded,
    filterFromTable,
    multiFilterFromTable,
    isEmptyObj,
    getNestedError,
    fileDownload,
    RolePermission,
    renderName,
    renderPayerName,
    patientFilter,
    sortLegs,
    InactivityHandler,
    fileUpload,
    usePaginatedFetch,
    dontAllowChangesLegStatuses,
    useTimeRulesSync
} from "./hooks";
export {
    ModalProvider,
    Modals,
    useModal,
    PrimaryModalProvider,
    PrimaryModal,
    usePrimaryModal,
    SecondaryModalProvider,
    SecondaryModal,
    useSecondaryModal,
    DetailModalProvider,
    DetailModal,
    useDetailModal,
    ModalMainProvider,
    useModalMain,
} from "./context";
export {EmailValidator, PasswordValidator} from "./validators";
export {
    limit,
    ACCOUNT_ENUMS,
    userType,
    isAdmin,
    localInfo,
    isEmployee,
    PermissionsList,
} from "./constants";
export {CountryList, states, languages} from "./jsons";
export {
    newDateWithoutUtc,
    newDateWithoutUtcCalendar,
    setDateOfTime,
    convertToTime,
    convertTo12HourFormat,
    getTimeAmOrPm,
    toAmPm,
    convertToAmPm,
    subtractMinutesFromTime
} from "./dateConverter";
export {calculateAge, calculateTotals} from './calculations'

export const token = localStorage.getItem("access-token");
export const userInfo =
    localStorage.getItem("careTechUserInfo") &&
    JSON.parse(localStorage.getItem("careTechUserInfo"));

export const fileMaxSize = 10 * 1024 * 1024;
